(() => {
  if (!customElements.get('lpl-research-disclosures')) {
    customElements.define('lpl-research-disclosures', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-research-toggle]');
          if (button && this.contains(button)) this.toggle(button);
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const block = event.target.closest('[data-research-block]');
          const button = block?.querySelector('[data-research-toggle]');
          if (button) this.toggle(button, true);
        }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
      setOpen(button, open) {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel || !this.contains(panel)) return;
        button.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
        const glyph = button.querySelector('[data-research-glyph]');
        if (glyph) glyph.textContent = open ? '–' : '+';
      }
      toggle(button, force) {
        const open = force ?? button.getAttribute('aria-expanded') !== 'true';
        if (open && this.hasAttribute('data-single-open')) {
          this.querySelectorAll('[data-research-toggle][aria-expanded="true"]').forEach(other => {
            if (other !== button) this.setOpen(other, false);
          });
        }
        this.setOpen(button, open);
      }
    });
  }
  if (!customElements.get('lpl-research-sticky')) {
    customElements.define('lpl-research-sticky', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { passive: true, signal: this.controller.signal };
        const schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        };
        this.addEventListener('lpl:sticky-resume', schedule, options);
        window.addEventListener('scroll', schedule, options);
        window.addEventListener('resize', schedule, options);
        this.update();
      }
      update() {
        if (matchMedia('(max-width: 749px)').matches) { window.LplMobileSticky?.schedule(); return; }
        const visible = window.scrollY > Math.max(560, window.innerHeight * .85);
        this.classList.toggle('is-visible', visible);
        this.inert = !visible;
        this.setAttribute('aria-hidden', String(!visible));
      }
      disconnectedCallback() { this.controller?.abort(); if (this.frame) cancelAnimationFrame(this.frame); this.frame = null; }
    });
  }
})();
